<script>

    import BIMITool from './bimi/bimiTool.svelte';
    import DMARCTool from './dmarc/dmarcTool.svelte';
    import DKIMTool from './dkim/dkimTool.svelte';
    import SPFTool from './spf/spfTool.svelte';

    const { drupalSettings, Drupal } = window;

    const options = {
    'bimi': { component: BIMITool },
    'dmarc': { component: DMARCTool },
    'dkim': { component: DKIMTool },
    'spf': { component: SPFTool },
  };

  const myData = document.getElementById('tool-block')?.getAttribute('data-app-id') || 'Default Value';
  let selectedTool = myData;
  let selected = options[selectedTool];

  </script>

 
  <!-- <svelte:component this={selected.component} domainName={drupalSettings.fortra_tools.domain_name} /> -->
  <svelte:component this={selected.component} />